import { InternalAxiosRequestConfig } from 'axios'
import lodash from 'lodash'

export const headerInterceptors = {
  success: async (options: InternalAxiosRequestConfig) => {
    let { headers, data } = options
    switch (headers['Content-Type']) {
      case 'application/json;charset=UTF-8':
        data = JSON.stringify(data)
        break
      case 'application/json':
        break
      case 'application/x-www-form-urlencoded':
        break
      case 'form-data':
      case 'multipart/form-data':
        break
      case null:
      case undefined:
        lodash.unset(headers, 'Content-Type')
        const formData = new FormData()
        lodash.mapValues(data, (value, key) => {
          formData.append(key, value)
        })
        options.data = formData
        options.headers['Content-Type'] = null
        break
      default:
        break
    }
    return options
  },
  fail: () => {}
}
